<header class="fxg-header fxg-header--sticky">
    <div class="global_navigation">
        <nav class="fxg-nav fdx-c-navbar--full-width">

            <div class="fxg-wrapper2 header-nav-menu-wrapper">

                <ul class="fxg-dropdown fxg-global-nav ham-menu-icon" [hidden]="router.url === '/home'" *ngIf="showOpenCloseBtn">
                    <div class="dropdown section">
                        <a class="fxg-link fxg-dropdown-js fxg-keyboard fxg-menu">

                            <img *ngIf="!opened" (click)="toggle()" class=""
                                src="/assets/svg/menu/icon_menu_white_rev_16x16.svg" width="16px" height="16px" />

                            <img *ngIf="opened" (click)="toggle()" class=""
                                src="/assets/svg/close/icon_close_white_rev_16x16.svg" width="16px" height="16px" />
                        </a>
                    </div>
                </ul>
                
                <a class="fxg-header__logo_wrapper fxg-keyboard" [routerLink]="['/home']" target="_self"
                    aria-label="FedEx Supply Chain Logo">
                    <span class="fxg-mouse" tabindex="-1">
                        <img src="/assets/images/fedex_logo.png" class="fxg-header__logo" style="min-width:120px;"
                            alt="FedEx Supply Chain Logo" />
                    </span>
                </a>

                <ul class="fxg-dropdown fxg-global-nav">
                    <div class="dropdown section">
                        <li class="fxg-dropdown__item">
                            <a class="fxg-link fxg-dropdown-js fxg-keyboard" [hidden]="router.url === '/home'"
                                target="_self"><span class="fxg-mouse" tabindex="-1" translate> {{commonService.headerMenuTitle}}
                                </span></a>
                        </li>
                    </div>
                </ul>

                <div class="fdx-utilityWrap" [ngClass]="{'xs-menu-opened': toggleXsMenu === true }">

                    <ul class="fxg-dropdown fxg-global-nav mx-2">
                        <li class="fxg-dropdown__item mx-2" [ngClass]="{'fxg-dropdown__item--open': retailerState === true}"
                            (mouseenter)="checkRetailer($event)" (mouseleave)="checkRetailer($event)" *ngIf="showFlag === true" #manageRetailers>
                            <a class="fxg-link fxg-dropdown-js fxg-keyboard" target="_self"
                                *ngIf="userName === '' && showFlag === true">
                                <span class="fxg-mouse" tabindex="-1" *ngIf="!isSmallScreen">
                                    {{"COMMON.CommonHeaderPlaceholder_Manageretailers" | translate: {Default: "Manage Retailers"} }}
                                </span>
                                <svg class="fdx-c-icon ml-2 fdx-u-font-size--small" aria-hidden="true" focusable="false"
                                    role="presentation">
                                    <use xlink:href="#chevron"></use>
                                </svg>
                            </a>
                            <a class="fxg-link fxg-dropdown-js fxg-keyboard fdx-u-color--white"
                                *ngIf="userName !== '' && showFlag === true">
                                <span class="fdx-u-pr--2">{{userName}}</span>
                                <svg class="fdx-c-icon fdx-u-font-size--h5" aria-hidden="true" focusable="false"
                                    role="presentation">
                                    <use href="#circle-user" xlink:href="#circle-user"></use>
                                </svg>
                                <svg class="fdx-c-icon ml-2 fdx-u-font-size--small" aria-hidden="true" focusable="false"
                                    role="presentation">
                                    <use xlink:href="#chevron"></use>
                                </svg>
                            </a>
                            <div class="fxg-dropdown__sub-menu" #customersSubMenu>
                                <div class="link section" *ngFor="let cust of customers">
                                    <div class="link">
                                        <a target="_self"
                                            class="fxg-link js-fxgc-init default fxg-tablet--hide fxg-mobile--hide"
                                            (click)="selectedCustomer(cust, 'reload')">{{cust.customerName}}</a>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li class="fxg-dropdown__item mx-2" [ngClass]="{'fxg-dropdown__item--open': facilityState === true}"
                            (mouseenter)="onHoverFacility($event)" (mouseleave)="onHoverFacility($event)"
                            *ngIf="showFlag === true && displayFacilitiesDropdown === true">
                            <a class="fxg-link fxg-dropdown-js fxg-keyboard" target="_self"
                                *ngIf="facilityName === '' && displayFacilitiesDropdown === true">
                                <span class="fxg-mouse" tabindex="-1" *ngIf="!isSmallScreen">
                                    {{"COMMON.CommonHeaderPlaceholder_Managefacilities" | translate: {Default: "Manage Facilities"} }}
                                </span>
                                <svg class="fdx-c-icon ml-2 fdx-u-font-size--small" aria-hidden="true" focusable="false"
                                    role="presentation">
                                    <use xlink:href="#chevron"></use>
                                </svg>
                            </a>
                            <a class="fxg-link fxg-dropdown-js fxg-keyboard fdx-u-color--white"
                                *ngIf="facilityName !== '' && displayFacilitiesDropdown === true">
                                <span class="fdx-u-pr--2">{{facilityName}}</span>
                                <svg class="fdx-c-icon fdx-u-font-size--h5" aria-hidden="true" focusable="false"
                                    role="presentation">
                                    <use xlink:href="#utility_office"></use>
                                </svg>
                                <svg class="fdx-c-icon ml-2 fdx-u-font-size--small" aria-hidden="true" focusable="false"
                                    role="presentation">
                                    <use xlink:href="#chevron"></use>
                                </svg>
                            </a>
                            <div class="fxg-dropdown__sub-menu retailers-submenu" #retailersSubMenu>
                                <div class="link section" *ngFor="let fac of buFacilityArrwAccess">
                                    <div class="link">
                                        <a target="_self"
                                            class="fxg-link js-fxgc-init default fxg-tablet--hide fxg-mobile--hide"
                                            (click)="selectedBuFacility(fac,'reload')">{{fac.lookupCodeDescription}}</a>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li class="fxg-dropdown__item mx-2" [ngClass]="{'fxg-dropdown__item--open': langState === true}" (mouseenter)="onHoverLang($event)" (mouseleave)="onHoverLang($event)">
                            <a class="fxg-link fxg-dropdown-js fxg-keyboard" target="_self" *ngIf="langCode === ''">
                                <span class="fxg-mouse fdx-u-pr--2" tabindex="-1" *ngIf="!isSmallScreen" style="padding-right: 1.975rem!important">Select lang</span>
                                <svg class="fdx-c-icon fdx-u-font-size--h5" aria-hidden="true" focusable="false" role="presentation">
                                    <use href="#utility_lang" xlink:href="#utility_lang"></use>
                                </svg>
                                <svg class="fdx-c-icon ml-2 fdx-u-font-size--small" aria-hidden="true" focusable="false" role="presentation">
                                    <use xlink:href="#chevron"></use>
                                </svg>
                            </a>
                            <a class="fxg-link fxg-dropdown-js fxg-keyboard fdx-u-color--white" *ngIf="langCode !== ''">
                                <span class="fdx-u-pr--2">{{langCode}}</span>
                                <svg class="fdx-c-icon fdx-u-font-size--h5" aria-hidden="true" focusable="false" role="presentation">
                                    <use href="#utility_lang" xlink:href="#utility_lang"></use>
                                </svg>
                                <svg class="fdx-c-icon ml-2 fdx-u-font-size--small" aria-hidden="true" focusable="false" role="presentation">
                                    <use xlink:href="#chevron"></use>
                                </svg>
                            </a>
                            <div class="fxg-dropdown__sub-menu language-submenu" #languagesSubMenu>
                                <div class="link section" *ngFor="let lItem of langList">
                                    <div class="link">
                                        <a *ngIf="lItem.code != userLang" target="_self" class="fxg-link js-fxgc-init default fxg-tablet--hide fxg-mobile--hide" (click)="onSwitchLanguage(lItem.code)">{{lItem.lang}}</a>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="fxg-dropdown__item mx-2 my-4" *ngIf="saveLangLoader">
                            <div class="fdx-c-loading-indicator" style="top: -5px;">
                                <div class="fdx-c-loading-indicator__part fdx-c-loading-indicator__part-white"></div>
                                <div class="fdx-c-loading-indicator__part fdx-c-loading-indicator__part-white"></div>
                                <div class="fdx-c-loading-indicator__part fdx-c-loading-indicator__part-white"></div>
                                <div class="fdx-c-loading-indicator__part fdx-c-loading-indicator__part-white"></div>
                            </div>
                        </li>
                        <li class="fxg-dropdown__item mx-2 my-4" *ngIf="userDBLang != userLang">
                            <button class="fdx-c-button fdx-c-button--secondary-outline" style="min-height: 1.5rem; padding: 10px; font-size: .875rem; " (click)="handleModalEvent('save')">
                                <span class="fdx-u-pr--2" style="font-weight: normal; font-size: .8rem;">{{"APP.AppButton_Save" | translate: {Default: "SAVE"} }}</span>
                                <svg class="fdx-c-icon fdx-u-font-size--h5" aria-hidden="true" focusable="false" role="presentation">
                                    <use href="#utility_lang" xlink:href="#utility_lang"></use>
                                </svg>
                            </button>
                        </li>

                        <ul class="fxg-dropdown fxg-global-nav my-auto mx-2 md-logout-nav">
                            <li class="fxg-dropdown__item">
                                <a class="fxg-link fxg-dropdown-js fxg-keyboard" style="height: 70px !important;" [routerLink]="['']" (click)="logout()"
                                    title="{{'COMMON.CommonHeaderLink_Signout' | translate: {Default: 'Sign Out'} }}">
                                    <img src="/assets/svg/export/icon_export_white_rev_32x32.svg" />
                                </a>
                            </li>
                        </ul>
                    </ul>

                    <!-- UTILITY NAV END -->
                </div>
                <div class="xs-menu-wrapper">
                  <div class="xs-nav-menu-icon" (click)="toggleXsMainMenu()">
                        <span class="menu-dot"></span>
                        <span class="menu-dot"></span>
                        <span class="menu-dot"></span>
                    </div>
                    <ul class="fxg-dropdown fxg-global-nav my-auto mx-2 xs-logout-nav">
                        <li class="fxg-dropdown__item">
                            <a class="fxg-link fxg-dropdown-js fxg-keyboard" style="height: 70px !important;" [routerLink]="['']" (click)="logout()"
                                title="{{'COMMON.CommonHeaderLink_Signout' | translate: {Default: 'Sign Out'} }}">
                                <img src="/assets/svg/export/icon_export_white_rev_32x32.svg" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</header>

<app-confirmmodal *ngIf="displayLangConfirmModal" 
modalDialogBodyContent="{{'COMMON.CommonMessage_Areyousureyouwanttosaveyourlanguagebeforeswitch' | translate: {Default: 'Are you sure you want to Save your language before Switch?'} }}" modalDialogType='MEDIUM' textContentStyle='center' buttonContentStyle='center' 
(cancelModalDialogEvent)="handleModalEvent('cancel')" 
(submitModalDialogEvent)="handleModalEvent('save')" 
modalButtonVal="{{'APP.AppButton_Save' | translate: {Default: 'SAVE'} }}"
thirdBtnShow="true" modalButtonForThirdBtn="{{'APP.AppButton_Switch' | translate: {Default: 'SWITCH'} }}"
(thirdModalDialogEvent)="handleModalEvent('switch')" >
</app-confirmmodal>

<app-successmodal *ngIf="displaySuccessModal" [modalDialogBodyContent]="successContent" modalDialogType='MEDIUM' (closeSuccessModalDialogEvent)="handleCloseEventForSuccess()">
</app-successmodal>
